import axios from 'axios';
import { useEffect, useState } from 'react';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTestimonials();
    }, []);

    const fetchTestimonials = async () => {
        try {
            const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
            const response = await axios.get(`${API_URL}/reviews?approved=true&limit=6`);

            if (response.data.data) {
                setTestimonials(response.data.data.slice(0, 6)); // Get latest 6 reviews
            }
        } catch (error) {
            console.error('Error fetching testimonials:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <section className="testimonials section" style={{ background: 'var(--bg-light)' }}>
                <div className="container">
                    <div className="section-title">
                        <h2>What Our Travelers Say</h2>
                        <p>Real experiences from our amazing customers</p>
                    </div>
                    <div className="spinner"></div>
                </div>
            </section>
        );
    }

    if (testimonials.length === 0) {
        return null; // Don't show section if no testimonials
    }

    return (
        <section className="testimonials section" style={{ background: 'var(--bg-light)' }}>
            <div className="container">
                <div className="section-title">
                    <h2>What Our Travelers Say</h2>
                    <p>Real experiences from our amazing customers</p>
                </div>

                <div className="testimonials-grid">
                    {testimonials.map((testimonial) => (
                        <div key={testimonial._id} className="testimonial-card card fade-in">
                            <div className="quote-icon">
                                <FaQuoteLeft />
                            </div>

                            <div className="testimonial-rating">
                                {[...Array(5)].map((_, i) => (
                                    <FaStar
                                        key={i}
                                        className={i < testimonial.rating ? 'star-active' : 'star-inactive'}
                                    />
                                ))}
                            </div>

                            <p className="testimonial-text">"{testimonial.comment}"</p>

                            <div className="testimonial-author">
                                <div className="author-avatar">
                                    {testimonial.customer.name.charAt(0).toUpperCase()}
                                </div>
                                <div className="author-info">
                                    <h4>{testimonial.customer.name}</h4>
                                    {testimonial.tour && (
                                        <p className="tour-name">{testimonial.tour.title}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
